<template>
    <div class="elegant-collapse">
        <div class="collapse-container" :style="{ 'text-align': align }">
            <div class="collapse-trigger" @click="$emit('toggle')">
                <span class="trigger-text">{{ isCollapsed ? collapseText : expandText }}</span>
                <div class="trigger-icon" :class="{ 'collapsed': !isCollapsed }">
                    <svg viewBox="0 0 24 24">
                        <path d="M7 10l5 5 5-5z" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CollapseButton',
    props: {
        isCollapsed: {
            type: Boolean,
            default: false
        },
        align: {
            type: String,
            default: 'right',
            validator: value => ['left', 'center', 'right'].includes(value)
        },
        expandText: {
            type: String,
            default: '显示更多'
        },
        collapseText: {
            type: String,
            default: '收起'
        }
    }
}
</script>

<style scoped>
.elegant-collapse {
    align-content: center;
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.collapse-trigger {

    display: inline-flex;
    align-items: center;
    cursor: pointer;
    color: #409EFF;
    transition: all 0.3s;
    user-select: none;
    margin-bottom: 0px;
}

.collapse-trigger:hover {
    color: #66b1ff;
}

.trigger-text {
    font-size: 14px;
    margin-right: 6px;
}

.trigger-icon {
    transition: transform 0.3s;
}

.trigger-icon svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
}

.trigger-icon.collapsed {
    transform: rotate(-90deg);
}

.collapse-content {
    transition: max-height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
}

.collapse-content.collapsed {
    max-height: 0;
    opacity: 0;
}

/* --------折叠按钮区域1 2--------- */
</style>